import axiosInstance from "../../../utils/axios";

const path = "business/auth";

export const login = async (values) => {
  return await axiosInstance().post(`${path}/login`, values);
};

export const forgetPassword = async (values) => {
  return await axiosInstance().post(`${path}/forget-password`, values);
};

export const otpVerification = async (values) => {
  return await axiosInstance().post(`${path}/verify-otp`, values);
};

export const resetPassword = async (values) => {
  return await axiosInstance().post(`${path}/reset-password`, values);
};

export const resendOtp = async (values) => {
  return await axiosInstance().post(`${path}/resend-otp`, values);
};

export const registerBusiness = async (values) => {
  return await axiosInstance().post(`${path}/register`, values);
};

export const verifyOTPRegister = async (values) => {
  return await axiosInstance().post(`${path}/verify-register-otp`, values);
};

export const resendRegisterOtp = async (values) => {
  return await axiosInstance().post(`${path}/resend-register-otp`, values);
};

export const categoriesList = async (values) => {
  return await axiosInstance().get(`${path}/categories-list`, values);
};

export const subcategoriesList = async (values) => {
  return await axiosInstance().post(`${path}/subcategories-list`, values);
};

export const CMS = async ({ values, slug }) => {
  return await axiosInstance().get(`${path}/cms-page?slug=${slug}`, values);
};
